type RawItem = Record<string, any>;

interface FormatMetricProps {
  metricKey: string;
  compareKey?: string;
  additionalSeries?: { seriesKey: string; }[];
}

export function formatMetricData(data: RawItem[], props: FormatMetricProps) {
  const { metricKey, compareKey, additionalSeries = [] } = props || {};

  return data?.map((item) => {
    const mainMetric: Record<string, string> = {
      value: String(item?.[metricKey] ?? ''),
    };

    if (compareKey) {
      mainMetric.last_value = String(item?.[compareKey] ?? '');
    }

    for (const { seriesKey } of additionalSeries) {
      if (seriesKey !== metricKey) {
        mainMetric[seriesKey] = String(item?.[seriesKey] ?? '');
      }
    }

    return {
      date: item.date,
      metrics: { [metricKey]: mainMetric },
    };
  });
}
